export enum ImportResultStatus {
  ACCEPTED = 'ACCEPTED',
  PARTIAL = 'PARTIAL',
  REJECTED = 'REJECTED',
}
